import React, { useEffect, useState, useRef, Fragment } from 'react'
// import {v4 as uuid} from 'uuid'

// Hooks
import useWindowSize from '../../../../Hooks/useWindowSize'
//import useRouter from 'Hooks/useRouter'

//Libraries
import Slider from "react-slick";

// Molecules
import PlayComPlanCardMol from '../../../Molecules/Cards/Plan/PlayCompare_'
import AnotherComparePlanCardMol from '../../../Molecules/Cards/Plan/AnotherCompare'
import PlayComPlanCardMolDetail from '../../../Molecules/Cards/Plan/PlayDetailCompare'
import PlayComPlanCardMolDetailEmpty from '../../../Molecules/Cards/Plan/PlayDetailCompareEmpty'

// Sass
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../../../Sass/includes/Components/modules/C25v2.sass'

function C25Personas(props) {

	let dataCompare = props.dataCompare ? props.dataCompare : []
	const {
		resetHandleClick,
		removeItemHandleClick,
		// optionsCiudadesLogic,
		setRegresaPlanes,
		symbolPrice
	} = props

	const {postPagoCarac} = props

	const [itemsDataCompare, setItemsDataCompare] = useState(dataCompare)
	
	// Hooks
    //const router = useRouter()

    const {
        width: widthWindos, 
        // height: wheightWindos, 
    } = useWindowSize()

	// Ref
	const itemsHeadRef = useRef([]);
	const itemsPriceRef = useRef([]);
	

	// states
	const [itemsResponsive, setItemsResponsive] = useState([])
	const [settingsCompare] = useState({
		dots: false,
		nav: true,
		infinite: false,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 960,
				settings: "unslick"
			}
		]
	});
	// Slider seguimiento de slider reference: https://stackblitz.com/edit/react-nkwgpt?file=src%2FApp.js
	const [nav1, setNav1] = useState();
	const [nav2, setNav2] = useState();

	const [itemAnother] = [{ fi_PLAN: 0}]
	// Bloques head and price of cards for equal heigth
	// const [heigthHead, setHeigthHead] = useState(0)
	// const [heigthPrice, setHeigthPrice] = useState(0)

	//Se añade elementro de añadir otro
	useEffect(()=>{
		if(dataCompare.items.length < 5){
			// setItemsDataCompare(prevState=>({
			// 	items: prevState.items.filter(item => item.id !== itemAnother.id),
			// 	isFetching: prevState.isFetching
			// }))
			setItemsDataCompare(prevState=>({
				items: [...prevState.items, itemAnother],
				isFetching: prevState.isFetching
			}))
		}
		// eslint-disable-next-line  
	},[])

	useEffect(()=>{
        setItemsResponsive([dataCompare.items[0]?.fi_PLAN, itemsDataCompare.items[1]?.fi_PLAN])
		// eslint-disable-next-line  
	},[])

	// const resizeHeadCards = () =>{
	// 	console.log("Elementos Head", itemsHeadRef)
	// 	console.log("Elementos Head current", itemsHeadRef.current)
	// 	console.log("widht", widthWindos)
	// 	if(itemsHeadRef){
	// 		setHeigthHead(0)
	// 		console.log("Elementos Head 2", itemsHeadRef)
	// 		console.log("Elementos Head 2 Current", itemsHeadRef.current)
	// 		const valuesHeightHead = []
	// 		console.log(valuesHeightHead)
	// 		console.log(Object.keys(itemsHeadRef.current).forEach(function(key, index) {
	// 			console.log("key y index", key, index) 
	// 		}))
	// 		Object.keys(itemsHeadRef.current).forEach(function(key, index) {
	// 			console.log("heigth Head" + index + " " + key, itemsHeadRef.current[key]?.clientHeight)
	// 			valuesHeightHead[index] = itemsHeadRef.current[key]?.clientHeight
	// 		})
			
	// 		console.log("Values pure", valuesHeightHead)
	// 		console.log("values", valuesHeightHead.filter(element => element !== undefined))
			
	// 		setHeigthHead(Math.max(...valuesHeightHead.filter(element => element !== undefined)))
	// 		console.log(Math.max(...valuesHeightHead.filter(element => element !== undefined)))
	// 	}
	// }

	// useEffect(()=>{
	// 	resizeHeadCards()
	// },[itemsHeadRef, widthWindos])

	// useEffect(()=>{
	// 	console.log("Elementos Price", itemsPriceRef)
	// 	if(itemsPriceRef){
	// 		setHeigthPrice(0)
	// 		const valuesHeightPrice = []
	// 		if(itemsPriceRef.current){
	// 			Object.keys(itemsPriceRef.current).forEach(function(key, index) {
	// 				console.log("heigth Price" + index + " " + key,itemsPriceRef.current[key]?.clientHeight)
	// 				valuesHeightPrice[index] = itemsPriceRef.current[key]?.clientHeight 
	// 			})
	// 			console.log("values", valuesHeightPrice.filter(element => element !== undefined))
	// 			setHeigthPrice( Math.max(...valuesHeightPrice.filter(element => element !== undefined)))
	// 			console.log(Math.max(...valuesHeightPrice.filter(element => element !== undefined)))
	// 		}
	// 	}
	// },[itemsPriceRef])


	// // Ref Heads html
	useEffect(()=>{
		console.log(itemsHeadRef)
	}, [itemsHeadRef])
	// Ref Prices html
	useEffect(()=>{
		console.log(itemsPriceRef)
	},[itemsPriceRef])

	// Items seleccionados para ver en movil (IDs)
	// useEffect(()=>{
	// 	console.log("itemsResponsive", itemsResponsive)
	// },[itemsResponsive])

	// // Items 
	// useEffect(()=>{
	// 	console.log("Items Comparados ahora", itemsDataCompare)
	// },[itemsDataCompare])

	const itemsId = widthWindos > 960 ? dataCompare.items.map(item => item.fi_PLAN) : itemsResponsive
    const findItemIndex = (item) => dataCompare.items.findIndex(el => el.fi_PLAN === item.fi_PLAN ) 

	const handlePrevPlan = (item, i)=>{
        const newResposive = [...itemsResponsive]
        console.log('index ant al valor actual:', findItemIndex(item) - 1 )

        newResposive[i] = findItemIndex(item) 
            ? dataCompare.items[ findItemIndex(item) - 1 ]?.fi_PLAN === itemsResponsive[i - 1] //Comprueba si el valor anterior no es el mismo que ya esta en el anterior index
                ? item.fi_PLAN //retorna el valor de elemento actual
                : dataCompare.items[ findItemIndex(item) - 1 ]?.fi_PLAN //retorna el nuevo valor
            : item.fi_PLAN
        setItemsResponsive(newResposive)
    }

    const handleNextPlan = (item, i)=>{
        console.log(itemsResponsive)
        console.log('index sig al valor actual:', findItemIndex(item) + 1 )
        
        const newResposive = [...itemsResponsive] 
        newResposive[i] = dataCompare.items[ findItemIndex(item) + 1 ]?.fi_PLAN   
            ? dataCompare.items[ findItemIndex(item) + 1 ]?.fi_PLAN  === itemsResponsive[i + 1] //comprueba  si el valor siguiente no es el mismo que ya esta en el siguirnte index
                ? item.fi_PLAN //retorna el valor de elemento actual
                : dataCompare.items[ findItemIndex(item) + 1 ]?.fi_PLAN //retorna el nuevo valor
            : item.fi_PLAN
        setItemsResponsive(newResposive)
    }


	const anotherComparePlanCard = (item, index) => (
		<div 
			key={ item && item.fi_PLAN ? (item.fi_PLAN ||index) : index }
			className="c25CompPlanCardsSld"
		>
			<div className="c25CompPlanCardsCompControl">
				<i className="ico-chevron-left" aria-label='Plan Anterior' onClick={()=>handlePrevPlan(item, index)}></i>
				<span>Comparar otro</span>
				<i className="ico-chevron-right" aria-label='Plan Siguiente' onClick={()=> handleNextPlan(item, index)}></i>
			</div>
			<AnotherComparePlanCardMol
				setRegresaPlanes={setRegresaPlanes}
				refHead={el => itemsHeadRef.current[index] = el} 
				itemsHeadRef={itemsHeadRef}
				refPrice={el => itemsPriceRef.current[index] = el} 
				itemsPriceRef={itemsPriceRef}
				//onClickAdd={()=>router.push('/personas/test3/')}
			/>
		</div>
	)

	const _renderCompare = items => (
        items && items.length > 0
            ?   items
				.filter(item => itemsId.includes(item.fi_PLAN) )
				.map( (item, index) => {
					console.log("mapaItems",item, itemAnother, (item.fi_PLAN !== itemAnother.fi_PLAN))
					if(item.fi_PLAN !== itemAnother.fi_PLAN){

						return(
							<>
								<div 
									key={item.id ||index }
									className={'c25CompPlanCardsSld'}
									
									
								>
									<div className="c25CompPlanCardsCompControl">
										<i className="ico-chevron-left" aria-label='Plan Anterior' onClick={()=>handlePrevPlan(item, index)}></i>
										<span>Comparar otro</span>
										<i className="ico-chevron-right" aria-label='Plan Siguiente' onClick={()=> handleNextPlan(item, index)}></i>
										{/* <span>
											{items.findIndex(el=>el.id === item.id) + 1} de {items.length} {'Planes'}
										</span> */}
									</div>
									<PlayComPlanCardMol
										refHead={el => itemsHeadRef.current[index] = el} 
										itemsHeadRef={itemsHeadRef}
										refPrice={el => itemsPriceRef.current[index] = el} 
										itemsPriceRef={itemsPriceRef}
										onClickDelete={removeItemHandleClick}
										item ={item}
										symbolPrice={symbolPrice}
										// optionsCiudadesLogic={optionsCiudadesLogic}
										// heigthHead={heigthHead}
										// heigthPrice={heigthPrice}
									/>
								</div>
							</>
						)
					}else{
						return(
							anotherComparePlanCard(item, index)
						)
					}
				}
				)
            :   anotherComparePlanCard([],Math.floor(Math.random() * (20 - 10 + 1) + 10))
		
    )

	const _renderCompareFeatures = items => (
        items && items.length > 0
            ?   items
				.filter(item => itemsId.includes(item.fi_PLAN) )
				.map( (item, index) =>{
					

					if(item.fi_PLAN !== itemAnother.fi_PLAN){

						return(
							<PlayComPlanCardMolDetail
								key={item.fi_PLAN ||index }
								item={item}
								postPagoCarac={postPagoCarac}
							/>
						)
					}else{
						return(
							<PlayComPlanCardMolDetailEmpty
								key={item.fi_PLAN ||index }
								item={item}
							/>
						)
					}

				}
				
				)
            :   ""
		
    )
	return (
		<Fragment>
			<section className="c25Wrap">
				<div className="container">
					<div className="c25Back">
						<div className="c25BackReturn">
							<a className="iconLink" onClick={resetHandleClick} href="#!">
								<i className="ico-chevron-left"></i>
								<span>Regresar a ver todos los planes</span>
							</a>
						</div>
					</div>
					<h1>
						Compara tus Servicios 
						{/* {JSON.stringify( itemsDataCompare.items.length)} */}
					</h1>
				</div>
				<div className="c25">
					<div className="c25CompPlanCards">
						<div className="container">							
							<Slider 
								key={0}
								{...settingsCompare} 
								asNavFor={nav2} ref={(slider1) => setNav1(slider1)}
								className={`c25CompPlanCardsSlider ${ dataCompare.items.length < 3? "twoElements": ""}`}
							>
								
								{dataCompare.isFetching 
                                    ? <div>Cargando...</div>
                                    : _renderCompare(dataCompare.items.slice(-5))
                                }						
									
								{dataCompare.items.length <= 1 
									? 
									anotherComparePlanCard( itemAnother,1) 
									: ""}

								{dataCompare.items.length <= 4 && dataCompare.items.length > 1
									? 
									anotherComparePlanCard( itemAnother,1) 
									: ""}
							</Slider>
						</div>
					</div>
					<div className="c25CompPlanCardsFeaturesList">
						<div className="container">
							<Slider 
								key={1}
								{...settingsCompare} 
								className="c25CompPlanCardsFeaturesListSlider"
								asNavFor={nav1}
        						ref={(slider2) => setNav2(slider2)}
							>
								{dataCompare.isFetching 
                                    ? <div>Cargando Caracteristicas...</div>
                                    : _renderCompareFeatures(dataCompare.items.slice(-5))
                                }
								{dataCompare.items.length < 1 ?  <PlayComPlanCardMolDetailEmpty/> :"" }
							</Slider>
						</div>
					</div>
					{/* Solo para pruebas */}
					{/* <div onClick={()=>
						setItemsDataCompare(prevState=>({
							items: [...prevState.items,  {
								id: uuid(),
								title: "Navega L Pro Añadido",
								exelentFor: "Para los que navegan todo el mes",
							},],
							isFetching: prevState.isFetching
						}))
					}>Añadir</div> */}
				</div>
			</section>
		</Fragment>
	)

}

export default C25Personas